import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { metadataService } from '../../_services/metadata.service'
//import { connect } from "react-redux";
//import { Alert } from 'reactstrap';
//import validator from 'validator';


export class ReadOnlyField extends Component {

    render() {
        if(this.props.vertical){
            return (
                <React.Fragment>
                    {this.props.showFieldLabel && (
                    <Row className='textFieldLabel'>{metadataService.getFieldNameLabel(this.props.name)}{this.props.showAsterisk && (<span>*</span>)}</Row>
                    )}                
                    <Row className='textFieldValue' >
                         {this.props.value}</Row>
                </React.Fragment>
            );
        }
        else{
            let cssClass = 'tableData' + this.props.valueAlignRight ? ' text-right' : this.props.valueAlignLeft ? ' text-left' : '';
            return (
              <Row>
                <Col className="tableLabel">
                  {metadataService.getFieldNameLabel(
                    this.props.name
                  )}
                  :
                </Col>
                <Col className={cssClass}>{this.props.value}</Col>
              </Row>
            );
        }

    }
}
ReadOnlyField.defaultProps = {
    showFieldLabel : true, 
    vertical : true, 
    valueAlignLeft: false , 
    showAsterisk: false
}
//Define prop types
ReadOnlyField.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string, 
    showFieldLabel: PropTypes.bool, 
    vertical: PropTypes.bool, 
    showAsterisk: PropTypes.bool 
}


// WEBPACK FOOTER //
// ./src/components/editors/readOnlyField.jsx